export enum PromoteOptions {
  ALL = "ALL",
  CUSTOMIZED = "CUSTOMIZED",
}

export const PromoteOptionsMapping: Record<PromoteOptions, string> = {
  [PromoteOptions.ALL]: "enumMapping.franchise.promote.all",
  [PromoteOptions.CUSTOMIZED]: "enumMapping.franchise.promote.customized",
};

export interface PromoteOptionsInterface {
  id: PromoteOptions;
  value: string;
}
